export default __webpack_public_path__ + "static/media/welcome_wave_large_desktop.6845af73.svg";